import { CONVERSATION_PLACEHOLDER } from '@web/conversations/consts/conversations';

import { ConversationState } from './conversationProvider.types';

export const conversationInitialState: ConversationState = {
  ...CONVERSATION_PLACEHOLDER,
  editMessageId: null,
  hasCustomUnreadMarker: false,
  hasScrollLocked: false,
  markedMessage: {
    id: null,
    isHighlighted: false,
  },
  memberIds: [],
  messages: {
    allIds: [],
    byId: {},
    visibleIds: [],
  },
  quotedMessageId: null,
  selectedMessageId: null,
};
